import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import Navbar from './Navbar';
import './ui.css';
import './NoAccess.css';

/* Экран вместо страницы, которую роль пользователя не открывает. Меню
   остаётся на месте, чтобы человек сразу ушёл туда, куда ему можно. */
const NoAccess = ({ home }) => {
  const { user, logout } = useAuth();

  return (
    <div className="no-access-page">
      <Navbar user={user} isAdmin={user?.role === 'admin'} onLogout={logout} />
      <div className="ui-card no-access">
        <svg className="no-access-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6"
             strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.75736 10 5.17157 10 8 10H16C18.8284 10 20.2426 10 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16Z" />
          <path d="M6 10V8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8V10" />
        </svg>
        <h2>Нет доступа к этому разделу</h2>
        <p className="ui-dim">
          Ваша роль{user?.role_name ? ` «${user.role_name}»` : ''} его не открывает.
          Если он нужен для работы, попросите администратора добавить раздел
          вашей роли в «Пользователи → Роли и доступ».
        </p>
        <Link to={home} className="ui-btn-primary">Перейти к своим разделам</Link>
      </div>
    </div>
  );
};

export default NoAccess;
